import type { FallbackRender } from "@sentry/react"
import { showReportDialog } from "@sentry/react"
import { useNavigate } from "@tanstack/react-router"
import { Button } from "@motleyhand/design"

type Props = Parameters<FallbackRender>[0]

export default function ErrorDisplay({ eventId }: Props) {
  const navigate = useNavigate()

  return (
    <div>
      <p className="text-lg">We have a CockUp! So Sorry!!</p>
      <div className="my-4 flex flex-row items-center gap-2">
        <Button
          variant="secondary"
          onClick={() => {
            showReportDialog({ eventId })
          }}
        >
          Tell us what happened
        </Button>
        <p>or</p>
        <Button
          variant="outline"
          onClick={() =>
            navigate({
              to: "/dashboard",
              reloadDocument: true,
            })
          }
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  )
}
